/**
 * Created by praveenningappa on 9/25/17.
 */
import React from 'react';
import PropTypes from 'prop-types';

export class Placeholder extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const styles = {
            height: `${this.props.height}`,
            width: `${this.props.width}`,
            borderRadius: `${this.props.borderRadius}`,
            margin: `${this.props.margin}`,
            float: `${this.props.float}`
        };
        return (
          this.props.type === 'animated' ? <div className="animated-placeholder" style={styles}></div> :
              <div className="plain-placeholder" style={styles}></div>
          );
    }
}

Placeholder.propTypes = {
    type: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
    borderRadius: PropTypes.string,
    margin: PropTypes.string,
    float: PropTypes.string
};

Placeholder.defaultProps = {
    type: 'animated',
    height: '100%',
    width: '100%',
    borderRadius: '0px',
    margin: '3px',
    float: 'none'
};



// WEBPACK FOOTER //
// ./src/components/SharedComponents/loading-state/placeholder.js